/**
 * 吐司渲染器(挂在 AppLayout)。固定右下角,3.5s 自动消散;可点关闭。
 * 视觉用 tokens 自洽(success/error/info 分色),不新造 token。
 */
import { useEffect } from 'react';
import { useToastStore, type ToastItem, type ToastType } from './toast';

const AUTO_DISMISS_MS = 3500;

const BORDER: Record<ToastType, string> = {
  success: 'var(--color-primary)',
  error: 'var(--color-destructive)',
  info: 'var(--color-border)',
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  // remove 是 zustand action,引用稳定 —— 直接下传,避免每次渲染新建闭包重置各行定时器。
  const remove = useToastStore((s) => s.remove);

  return (
    <div
      aria-live="polite"
      style={{
        position: 'fixed',
        right: 'var(--space-6)',
        bottom: 'var(--space-6)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-2)',
        zIndex: 80,
        maxWidth: 360,
      }}
    >
      {toasts.map((t) => (
        <ToastRow key={t.id} toast={t} onDismiss={remove} />
      ))}
    </div>
  );
}

function ToastRow({ toast, onDismiss }: { toast: ToastItem; onDismiss: (id: number) => void }) {
  // 依赖仅 id + 稳定的 onDismiss:新 toast 入列不会重置既有行的 3.5s 倒计时。
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(toast.id), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [toast.id, onDismiss]);

  return (
    <div
      role="status"
      onClick={() => onDismiss(toast.id)}
      className="card card-pad sm"
      style={{
        cursor: 'pointer',
        padding: 'var(--space-3) var(--space-4)',
        borderLeft: `3px solid ${BORDER[toast.type]}`,
        boxShadow: 'var(--shadow-lg)',
      }}
    >
      {toast.message}
    </div>
  );
}
